import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import {
  FileUploadModalBaseComponent
} from '../../shared/components/file-upload-modal/file-upload-modal-base.component';

import { EntitiesService, NotificationService } from '../../shared/services';
import { ModalService } from '../../shared/modules/modal';

import { TranslationConstants } from '../../shared/constants';

@Component({
  selector: 'import-entities-modal',
  templateUrl: './import-entities-modal.component.html',
})
export class ImportEntitiesModalComponent extends FileUploadModalBaseComponent {

  constructor(
    private _entitiesService: EntitiesService,
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    protected translate: TranslateService
  ) {
    super(notificationService, modalService, translate);
  }

  upload(): void {
    if (this.fileTypeInvalid) {
      return;
    }

    this.resetErrors();
    // if upload started or no file, do not trigger the API again
    if (this.showLoader || !this.fileToUpload) {
      return;
    }

    this.showLoader = true;
    this._entitiesService.uploadImportEntitiesFile(this.fileToUpload).subscribe(({ data }) => {
      this.columns = data.headers.map((header: string) => { return { header }; });
      this.allowedFields = data.allowed;
      this.filteredAllowedFields = data.allowed;
      this.fileHash = data.hash;
      this.showLoader = false;
      this.uploaded = true;
      this.handleDefaultFieldsForHeaders();
    });
  }

  startImport(): void {
    this.responseErrors = [];

    // if import started, do not trigger the API again
    if (this.showLoader) {
      return;
    }

    const payload = this.prepareImportPayload();
    if (payload.mappings.length === 0) {
      this.responseErrors.push(TranslationConstants.ERROR_IMPORT_NO_MAPPING);
      return;
    }

    this.showLoader = true;
    this._entitiesService.submitMappings(payload).subscribe(() => {
      this.showLoader = false;
      this.closeAllModals();
      this.success();
    });
  }
}
